(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-our-story"] && !Shopify.designMode) return;
  try {
    
  const storyReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const startStoryBackgrounds = () => {
    document.querySelectorAll('.hos--video video').forEach((video) => {
      video.controls = false;
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.loop = true;
      video.disablePictureInPicture = true;
      video.setAttribute('disableRemotePlayback', '');
      video.setAttribute('tabindex', '-1');
      video.autoplay = !storyReducedMotion.matches;
      if (storyReducedMotion.matches) {
        video.pause();
      } else if (document.visibilityState === 'visible') {
        const playback = video.play();
        if (playback) playback.catch(() => {});
      }
    });
  };
  startStoryBackgrounds();
  window.addEventListener('pageshow', startStoryBackgrounds);
  document.addEventListener('visibilitychange', startStoryBackgrounds);
  document.addEventListener('touchstart', startStoryBackgrounds, { passive: true, once: true });
  document.addEventListener('shopify:section:load', startStoryBackgrounds);
  storyReducedMotion.addEventListener('change', startStoryBackgrounds);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modular-homes-launch"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mh-scroll]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start'
      });
    });
  });

  document.querySelectorAll('[data-mh-video-play]').forEach((button) => {
    button.addEventListener('click', () => {
      const videoId = button.dataset.videoId;
      const host = button.dataset.videoHost;
      if (!videoId) return;

      const iframe = document.createElement('iframe');
      iframe.title = button.getAttribute('aria-label');
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;

      if (host === 'vimeo') {
        iframe.src = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
      } else {
        iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&controls=1&rel=0&playsinline=1`;
      }

      button.replaceWith(iframe);
    });
  });

  document.querySelectorAll('[data-mh-hosted-video-play]').forEach((button) => {
    button.addEventListener('click', () => {
      const video = button.parentElement.querySelector('video');
      if (!video) return;
      button.remove();
      const playback = video.play();
      if (playback) playback.catch(() => {});
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["starlight-room-gallery"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.starlight-rooms').forEach(gallery=>{const dialog=gallery.querySelector('dialog');let trigger;gallery.querySelectorAll('[data-starlight-room]').forEach(link=>link.addEventListener('click',event=>{event.preventDefault();trigger=link;const image=dialog.querySelector('img');image.src=link.href;image.alt=link.querySelector('img').alt;dialog.showModal()}));dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close()});dialog.addEventListener('close',()=>trigger?.focus())});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-technology-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const button = event.target.closest('.studio-tech__video-play');
    if (!button) return;
    const container = button.parentElement;
    const video = container.querySelector('video');
    const feedback = container.querySelector('.studio-tech__video-error');
    button.disabled = true;
    feedback.hidden = true;
    if (video.error) video.load();
    video.play().then(function () {
      container.classList.add('is-playing');
      button.hidden = true;
      button.disabled = false;
      video.focus();
    }).catch(function () {
      button.disabled = false;
      button.hidden = false;
      container.classList.remove('is-playing');
      feedback.hidden = false;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
